import { render, staticRenderFns } from "./ReviewExerciseEdit.vue?vue&type=template&id=c77fc184"
import script from "./ReviewExerciseEdit.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports